import { FC, PropsWithChildren, createContext, useEffect, useState } from "react";
import { ChassisType } from "../@types/ChassisType";
import Product from "../@types/Product";
import { DefaultCartModelDisplay } from "../components/CartModelDisplay/CartModelDisplay";

interface CartModel {
    setDefaults: React.Dispatch<React.SetStateAction<DefaultCartModelDisplay | undefined>>,
    chassisType: ChassisType | undefined,
    setChassisType: (chassisType: ChassisType | undefined) => void,
    bodyColor: Product | undefined,
    setBodyColor: (bodyColor: Product | undefined) => void,
    liftKit: Product | undefined,
    setLiftKit: (liftKit: Product | undefined) => void,
    wheel: Product | undefined,
    setWheel: (wheel: Product | undefined) => void,
    wheelSize: number | undefined,
    setWheelSize: (wheelSize: number | undefined) => void,
    frontSeat: Product | undefined,
    setFrontSeat: (seat: Product | undefined) => void,
    rearSeat: Product | undefined,
    setRearSeat: (seat: Product | undefined) => void,
}

const CartModelDisplayContext = createContext<CartModel | undefined>(undefined);

export const CartModelDisplayProvider: FC<PropsWithChildren> = ({ children }) => {
    const [defaults, setDefaults] = useState<DefaultCartModelDisplay | undefined>();
    const [chassisType, setChassisType] = useState<ChassisType | undefined>();
    const [bodyColor, setBodyColor] = useState<Product | undefined>();
    const [liftKit, setLiftKit] = useState<Product | undefined>();
    const [wheel, setWheel] = useState<Product | undefined>();
    const [wheelSize, setWheelSize] = useState<number | undefined>();
    const [frontSeat, setFrontSeat] = useState<Product | undefined>();
    const [rearSeat, setRearSeat] = useState<Product | undefined>();

    useEffect(() => {
        if (!defaults) {
            setBodyColor(undefined);
            setLiftKit(undefined);
            setWheel(undefined);
            setWheelSize(undefined);
            setFrontSeat(undefined);
            setRearSeat(undefined);
        } else {
            setChassisType(defaults.chassisType);
            setBodyColor(defaults.bodyColor);
            setLiftKit(defaults.liftKit);
            setWheel(defaults.wheel);
            setFrontSeat(defaults.frontSeat);
            setRearSeat(defaults.rearSeat);
        }
    }, [
        defaults,
        chassisType,
        setBodyColor,
        setLiftKit,
        setWheel,
        setWheelSize,
        setFrontSeat,
        setRearSeat
    ]);

    return (
        <CartModelDisplayContext.Provider
            value={{
                setDefaults,
                chassisType,
                setChassisType,
                bodyColor,
                setBodyColor,
                liftKit,
                setLiftKit,
                wheel,
                setWheel,
                wheelSize,
                setWheelSize,
                frontSeat,
                setFrontSeat,
                rearSeat,
                setRearSeat
            }}>
            {children}
        </CartModelDisplayContext.Provider>
    )
}

export default CartModelDisplayContext;